import { useState, useEffect, useRef } from 'react'

//-------------------------SUN---------------------------------//
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css' // Import Sun Editor's CSS File
import { sunConfig, sunIcons } from './data'
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked'

import './style.scss'

import ApiUtil from '../../../utils/apiUtil'

const SunEditorUI = ({
  name,
  value,
  onChange,
  config,
  editorType,
  mode,
  id,
  autoFocus,
  maxCharCount,
  buttonList,
  useValue,
  showInline,
  isToogleToolBar = false,
  height = null,
  placeholder = null,
  onOpenDrawer,
}: any) => {
  // const { t } = useTranslation("translation");
  //   const makeApiCall = useFetch();

  const [initialValue, setInitialValue] = useState(value)
  const editor: any = useRef()

  // if(isToogleToolBar) {
  //   editor.toolbar.hide()
  // }

  useEffect(() => {
    setInitialValue(value)
  }, [value])

  // The sunEditor parameter will be set to the core suneditor instance when this function is called
  // const getSunEditorInstance = (sunEditor: any) => {
  //   editor.current = sunEditor
  //   editor.current.toolbar.hide()
  //   editor.current.onFocus = () => {
  //     editor.current.toolbar.show()
  //   }

  //   editor.current.onBlur = () => {
  //     editor.current.toolbar.hide()
  //   }
  // }

  function handleImageUploadBefore(
    files: any,
    info: any,
    uploadHandler: any,
  ): any {
    const file_data = files[0]
    const formData = new FormData()
    formData.append('media', file_data)
    ApiUtil.SendAsync<any>({
      url: `media/images/upload`,
      method: 'POST',
      data: formData,
    }).then(json => {
      if (json.status === 200) {
        let response = {
          errorMessage: 'Image could not be uploaded',
          result: [
            {
              url: json.data.data.media.url,
              name: json.data.data.media.filename,
              size: file_data.size,
            },
          ],
        }
        uploadHandler(response)
      }
      return undefined
    })
  }

  const htmlDecode = (input: any) => {
    var e: any = document.createElement('div')
    e.innerHTML = input
    return e.innerText
  }

  const handlePaste = (e: any, cleanData: any) => {
    if (maxCharCount && editor && editor.current) {
      const currentCharCount = editor.current.getCharCount()
      const pasteText = htmlDecode(cleanData)
      if (pasteText.length + currentCharCount > maxCharCount) {
        const trimPasedText = pasteText.substr(
          0,
          maxCharCount - currentCharCount,
        )
        // let newData = editor.current.getContents() +  pasteText.substr(0, maxCharCount - currentCharCount);
        // editor.current.setContents(newData);
        document.execCommand('insertHtml', false, trimPasedText)
        e.preventDefault()
        e.stopPropagation()
        // editor.current.onChange(trimPasedText)
      }
    }
  }

  // const openDrawerPlugin = {
  //   name: 'openDrawerBtn',
  //   display: 'Open Drawer',
  //   add: function (core: any) {
  //     const button = core.util.createElement('BUTTON')
  //     button.className = 'se-btn'
  //     button.innerText = 'Open Drawer'
  //     button.addEventListener('click', () => {
  //       const selectedText = core.getSelection().toString()
  //       // Your drawer logic here
  //       console.log('Selected text:', selectedText)
  //     })
  //     core.addNode('openDrawerBtn', button)
  //   },
  // }

  // const openDrawerPlugin = {
  //   name: 'openDrawerBtn',
  //   display: 'Open Drawer',
  //   add: function (core: any) {
  //     // Create button container
  //     const button = core.util.createElement('BUTTON')
  //     button.className = 'se-btn se-btn-primary custom-drawer-btn'

  //     // Create icon container
  //     const iconContainer = document.createElement('span')
  //     iconContainer.className = 'drawer-button-container'
  //     iconContainer.innerHTML = `
  //       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  //         <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/>
  //       </svg>
  //     `

  //     // Add icon to button
  //     button.appendChild(iconContainer)

  //     // Add tooltip
  //     button.title = 'Open Drawer'

  //     // Add event listener
  //     button.addEventListener('click', () => {
  //       console.log('🚀 ~ button.addEventListener ~ click:')
  //       try {
  //         // Get selected text from editor
  //         const selectedText = core.getSelection().toString()
  //         console.log('Selected text from window selection:', selectedText)

  //         // Try alternative method if the above doesn't work
  //         const editorSelectedText = core.getSelectedText()
  //         console.log('Selected text from editor method:', editorSelectedText)

  //         // Another alternative
  //         const rangeText = core.getRange().toString()
  //         console.log('Selected text from range:', rangeText)

  //         // Use whatever text we can get
  //         const finalText =
  //           selectedText || editorSelectedText || rangeText || ''

  //         // Trigger parent handler if passed
  //         if (typeof onOpenDrawer === 'function') {
  //           onOpenDrawer(finalText)
  //         }
  //       } catch (error) {
  //         console.error('Error getting selected text:', error)
  //       }
  //     })

  //     // Add button to editor
  //     core.addNode('openDrawerBtn', button)

  //     // Add custom styles
  //     const style = document.createElement('style')
  //     style.textContent = `
  //       .custom-drawer-btn {
  //         display: flex;
  //         align-items: center;
  //         justify-content: center;
  //       }
  //       .drawer-button-container svg {
  //         width: 18px;
  //         height: 18px;
  //         fill: currentColor;
  //       }
  //     `
  //     document.head.appendChild(style)
  //   },
  // }

  // const openDrawerPlugin = {
  //   name: 'openDrawerBtn',
  //   display: 'Open Drawer',
  //   add: function (core: any) {
  //     const button = core.util.createElement('BUTTON')
  //     button.className = 'se-btn'
  //     button.innerText = 'Open Drawer'

  //     button.addEventListener('click', () => {
  //       const selectedText = core.getSelectedText?.()
  //       console.log('Selected text:', selectedText)

  //       // Trigger parent handler if passed
  //       if (typeof onOpenDrawer === 'function') {
  //         onOpenDrawer(selectedText)
  //       }
  //     })

  //     core.addNode('openDrawerBtn', button)
  //   },
  // }

  return (
    <>
      {editorType === 'sun' && (
        <SunEditor
          // getSunEditorInstance={getSunEditorInstance}
          showInline={showInline}
          height={height ? height : '180'}
          autoFocus={true}
          // key={id}
          name={name}
          placeholder={placeholder ? placeholder : 'Please type here...'}
          setContents={initialValue}
          // onBlur={(e, content) => onChange(content)}
          onChange={onChange}
          setOptions={{
            showPathLabel: false,
            mode: mode ? mode : 'classic',
            buttonList: buttonList ? buttonList : sunConfig,
            icons: sunIcons,
            maxCharCount: maxCharCount ? maxCharCount : null,
            charCounter: true,
            charCounterLabel: 'Charaters:',
            // plugins: [openDrawerPlugin],
            // buttonList: [['openDrawerBtn']],
          }}
          onImageUploadBefore={handleImageUploadBefore as any}
          onImageUploadError={(message: any, result: any) => {
            console.log('[ message, result ]', message, result)
          }}
          onPaste={handlePaste}
        />
      )}
    </>
  )
}

export default SunEditorUI
